import React from 'react'
import { Helmet } from 'react-helmet'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from 'src/pages/auth/auth-context'

import { useDataLayer } from '../../hooks/common/data-layer'

interface SeoRouteProps {
  title?: string
  description?: string
  canonical?: string
  children?: React.ReactNode
}

export const RequireSeo = ({
  title,
  description,
  canonical,
  children,
}: SeoRouteProps) => {
  const { pathname } = useLocation()
  useDataLayer(pathname)

  let urlCanonical = canonical || window.location.href
  if (!urlCanonical.match(/.*\/$/m)) urlCanonical += '/'

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <link rel="canonical" href={urlCanonical} />
        <link rel="alternate" hrefLang="pt-br" href={urlCanonical} />
        <script type="application/ld+json">
          {`
              {
                "@context":"http://schema.org",
                "@type":"BreadcrumbList",
                "itemListElement":[ 
                    { 
                      "@type":"ListItem",
                      "position":1,
                      "name":"Housi",
                      "item":"https://housi.com.br/"
                    },
                    { 
                      "@type":"ListItem",
                      "position":2,
                      "name":"${title}",
                      "item":"${urlCanonical}"
                    }
                ]

              }
            `}
        </script>
      </Helmet>
      {children}
    </>
  )
}

export const RequireAuth = (props: SeoRouteProps) => {
  const { isAuth } = useAuth()

  if (!isAuth) return <Navigate to="/" />

  return <RequireSeo {...props} />
}
